var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"chart-name"},[_vm._v(" 需求提交周趋势 "),_c('dv-decoration-3',{staticStyle:{"width":"200px","height":"20px"}})],1),_c('dv-charts',{staticStyle:{"height":"400px","width":"600px"},attrs:{"option":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }